import React, { type ComponentType, lazy, Suspense } from 'react';

import Loadable from 'react-loadable';

import { fg } from '@atlaskit/platform-feature-flags';

const DirectorySuspense = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_directory-page" */ './main'
		),
);

const LazyDirectoryNext = (): React.ReactElement => (
	<Suspense fallback={null}>
		<DirectorySuspense />
	</Suspense>
);

const LazyDirectoryLegacy: ComponentType<{}> & Loadable.LoadableComponent = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_directory-page" */ './main'
		),
	loading: () => null,
});
LazyDirectoryLegacy.displayName = 'lazy(LazyDirectory)';

const LazyDirectory = (): React.ReactElement =>
	fg('teams_app_react_19_upgrade') ? <LazyDirectoryNext /> : <LazyDirectoryLegacy />;

/**
 * In a new directory page we need to pass full path in order to keep
 * the component updated when doing manipulations with route
 * programmatically.
 */
const DirectoryRoute = (): React.JSX.Element => {
	return <LazyDirectory />;
};

export default DirectoryRoute;
